import React, { useState, useContext } from 'react';
import {Segment, Form, Button, Label, Dropdown, Icon, Popup} from 'semantic-ui-react';

import { observer } from 'mobx-react-lite';
import { Form as FinalForm, Field } from 'react-final-form';

import {
  combineValidators,
  composeValidators,
  hasLengthLessThan,
  isRequired,
} from 'revalidate';

import { RootStoreContext } from '../../../../App/stores/RootStore'
import TextInput from '../../../../App/common/form/TextInput';
import { AdminQuestionFormValues, IAdminQuestion } from '../../../../App/models/AdminQuestion';
import TextAreaInput from '../../../../App/common/form/TextAreaInput';
import CheckboxInput from '../../../../App/common/form/CheckboxInput';
const responseTypeList = [
    {
        text: 'yes/ no',
        value: 'bool'
    },
    {
        text: 'text',
        value: 'string'
    }
    // ,{
    //     text: 'date',
    //     value: 'date'
    // }
]
const validate = combineValidators({
  question: isRequired('question'),
  description: composeValidators(
    hasLengthLessThan(300)({ message: 'description has a 300 character limit' })
  )(),
});

interface QuestionParams {
  question: IAdminQuestion | undefined;
}

const QuestionForm: React.FC<QuestionParams> = (match) => {
  const rootStore = useContext(RootStoreContext);

  const { createAdminQuestion, editAdminQuestion, submitting } = rootStore.adminQuestionStore;
  const { closeModal } = rootStore.modalStore;
    const [responseType, setResponseType] = useState("")
  const [AdminQuestion] = useState(new AdminQuestionFormValues(match.question));
  const [loading] = useState(false);
    const handleResponseTypeChange = (event: any, data: any) => {
        setResponseType(data.value);

    }
  const handleFinalFormSubmit = (values: any) => {
    const { checked, ...adminQuestion } = values;
    adminQuestion.responseType = responseType
    //console.log(checked);
    //console.log(adminQuestion);
    if (!adminQuestion.id) {
      let newAdminQuestion = {
        ...adminQuestion
      };
      createAdminQuestion(newAdminQuestion);
    }
    else {
      editAdminQuestion(adminQuestion);
    }
  };


  return (
    <Segment clearing>
      <FinalForm
        validate={validate}
        initialValues={AdminQuestion}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, invalid, pristine }) => (
          <Form onSubmit={handleSubmit} loading={loading}>
            <Label>
              Question
                </Label>
            <Field
              rows={1}
              name='question'
              placeholder='question'

              value={AdminQuestion.question}
              component={TextInput}
            />
              <Label>
                  Response Type
              </Label>
              <Dropdown
                  placeholder='responseType'
                  fluid
                  search
                  selection
                  options={responseTypeList}
                  defaultValue={AdminQuestion.responseType}
                  onChange={handleResponseTypeChange}
              />
            {responseType === "bool" || AdminQuestion.responseType === "bool"?
                <>
                    <Label>
                    Passing Answer
                </Label>
                <Field
                    rows={3}
                    name='passingAnswer'
                    type='checkbox'
                    placeholder='passingAnswer'
                    checked={AdminQuestion.passingAnswer}
                    component={CheckboxInput}
                />
                </>
                :""}
              {responseType === "string" || AdminQuestion.responseType === "string"?
                  <>
                      <Label>
                          Passing Answer Text
                      </Label>
                      <Popup content='leave empty to allow any text value' trigger={
                          <Icon color='blue' flipped='vertically' name='exclamation'/>
                      } />

                      <Field
                          rows={4}
                          name='passingText'
                          placeholder='passingText'

                          value={AdminQuestion.passingText}
                          component={TextInput}
                      />

                  </>
                  :""}

            <Label>
              isIdentity
                </Label>
            <Field
              rows={3}
              name='isIdentity'
              type='checkbox'
              placeholder='isIdentity'
              checked={AdminQuestion.isIdentity}
              component={CheckboxInput}
            />
            <Label>
              Description
                </Label>
            <Field
              rows={5}
              name='description'
              placeholder='description'
              value={AdminQuestion.description}
              component={TextAreaInput}
            />
            <Button
              loading={submitting}
              disabled={loading || invalid || pristine || responseType === ""}
              floated='right'
              positive
              type='submit'
              content='submit'
            />
            <Button
              onClick={() => closeModal()}
              disabled={loading}
              floated='left'
              type='button'
              content='Cancel'
            />
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(QuestionForm);
